import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import s from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/Extension/WizardLeftSidebarExtension.module.scss";
import { WizardLeftSidebarItem } from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/Extension/WizardLeftSidebarItem";
import { useIsFetching, useWizardActions } from "stores/wizardStore";

export const WizardLeftSidebarZonesMenu = Scrivito.connect(
  ({
    isUserActionsDisabled,
    questionnaireLists = [],
    currentQuestionnaireIdentifier,
    step,
  }) => {
    const { getSelectedQuestionnaire } = useWizardActions();
    const isSomethingFetching = useIsFetching();
    const handleItemClick = useCallback(
      (id) => {
        if (!isSomethingFetching && id !== currentQuestionnaireIdentifier) {
          getSelectedQuestionnaire({ id });
        }
      },
      [
        currentQuestionnaireIdentifier,
        getSelectedQuestionnaire,
        isSomethingFetching,
      ],
    );

    return (
      <ul className={cx("ps-0 py-0 mt-5_5", s.zonesMenuWrapper)}>
        {questionnaireLists.map((item, index) => (
          <WizardLeftSidebarItem
            key={index}
            id={item.id}
            title={item.title}
            position={item.position}
            handleItemClick={handleItemClick}
            currentQuestionnaireIdentifier={currentQuestionnaireIdentifier}
            isUserActionsDisabled={isUserActionsDisabled}
            step={step}
          />
        ))}
      </ul>
    );
  },
);
